import { useRef, useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Eraser } from "lucide-react";

// Captura de firma manuscrita sobre un <canvas>. Expone la firma como Blob PNG
// a través de onChange cuando el trazo termina.
export default function SignaturePad({ onChange, testId = "signature-pad" }) {
  const canvasRef = useRef(null);
  const drawingRef = useRef(false);
  const [hasSignature, setHasSignature] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = "#BD3742";
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
  }, []);

  const getPos = (e) => {
    const rect = canvasRef.current.getBoundingClientRect();
    const point = e.touches ? e.touches[0] : e;
    return {
      x: ((point.clientX - rect.left) / rect.width) * canvasRef.current.width,
      y: ((point.clientY - rect.top) / rect.height) * canvasRef.current.height,
    };
  };

  const start = (e) => {
    drawingRef.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = getPos(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const move = (e) => {
    if (!drawingRef.current) return;
    e.preventDefault();
    const ctx = canvasRef.current.getContext("2d");
    const { x, y } = getPos(e);
    ctx.lineTo(x, y);
    ctx.stroke();
    setHasSignature(true);
  };

  const end = () => {
    if (!drawingRef.current) return;
    drawingRef.current = false;
    canvasRef.current.toBlob((blob) => onChange?.(blob), "image/png");
  };

  const clear = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    setHasSignature(false);
    onChange?.(null);
  };

  return (
    <div data-testid={testId}>
      <canvas
        ref={canvasRef}
        width={400}
        height={140}
        className="border border-gray-300 rounded-lg w-full touch-none cursor-crosshair bg-white"
        onMouseDown={start}
        onMouseMove={move}
        onMouseUp={end}
        onMouseLeave={end}
        onTouchStart={start}
        onTouchMove={move}
        onTouchEnd={end}
        data-testid={`${testId}-canvas`}
      />
      <Button type="button" variant="ghost" size="sm" onClick={clear} className="mt-1 text-gray-500" data-testid={`${testId}-clear-btn`}>
        <Eraser className="w-3.5 h-3.5 mr-1" /> Borrar firma
      </Button>
      {!hasSignature && <p className="text-xs text-gray-400 -mt-1">Firma aquí con el ratón o el dedo</p>}
    </div>
  );
}
